export const CONF_DOMAIN = "conf/";

export const GET_CONFIGURATION_FACILITY = CONF_DOMAIN + "/getConfigurationFacility";